import React from 'react';
import styled from "styled-components";
import FlexContainer from '../../FlexContainer';
import Tile from '../../Tile';
import satelliteImg from "./img/satellite.png";
import navigationImg from "./img/navigation.png";
import exploreImg from "./img/explore.png";
import { AlertOctagon } from 'react-feather';
import useViewerStore from '../../../store-zustand/viewer';
import * as Cesium from 'cesium';
import './style.css';

const MainTile = {
  backgroundImage: `linear-gradient(180deg, rgba(47, 47, 47, 0) 0%, rgba(37, 34, 34, 0.87) 98.96%), url(${satelliteImg})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  height: '16rem',
  fontSize: `${({ theme }) => theme.font.size.text.small}`,
  margin: '1rem 0',
  padding: '1.25rem',
  borderRadius: `${({ theme }) => theme.borderRadius.default}`,
  transition: 'background 0.35s',
  '&: hover': {
    cursor: 'pointer',
    // background: ${({ theme }) => theme.backgroundColor.tile.hover};
    backgroundImage: `linear - gradient(180deg, rgba(47, 47, 47, 0) 0 %, rgb(10, 10, 10) 98.96 %), url(${satelliteImg})`
  }
}


const strongStyle = {
  fontFamily: 'Roboto',
  fontWeight: '500',
  fontSize: '15px',
  lineHeight: '18px',
  color: '#E5E5E5',
  margin: '0 0 0.25rem'
}

const category = {
  fontFamily: "Open Sans",
  fontWeight: "500",
  fontSize: "12px",
  lineHeight: "16px",
  color: "#C4C4C4"
}


const MapThemes = () => {

  const { viewer } = useViewerStore();

  const setMapThem = async (keyword) => {
    const layers = viewer.scene.imageryLayers;
    //layers.removeAll(true);
    // for (var i = 0; i < layers._layers.length - 1; i++) {
    for (var i = 0; i < 2; i++) {
      //Clear all Mapbox Layers
      layers.remove(layers._layers[i], true);
    }
    //Add layer
    if (keyword == 'SAT') {
      viewer.imageryLayers.addImageryProvider(
        new Cesium.MapboxStyleImageryProvider({
          username: 'fastmap',
          styleId: 'ckoog99o80rqr17poritt9k6r',
          accessToken: 'pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g',
          tilesize: 512,
          maximumLevel: 22
        }), 0
      );
    }
    else if (keyword == 'Navigation') {
      viewer.imageryLayers.addImageryProvider(
        new Cesium.MapboxStyleImageryProvider({
          username: 'fastmap',
          styleId: 'ckoos0ctz0yim18ru0b0ks71x',
          accessToken: 'pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g',
          tilesize: 512,
          maximumLevel: 22
        }), 0
      );
    }
    else if (keyword == 'Explore') {
      viewer.imageryLayers.addImageryProvider(
        new Cesium.MapboxStyleImageryProvider({
          username: 'fastmap',
          styleId: 'ckoog7zhs0my918ruaxhclcqw',
          accessToken: 'pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja2N4Y3FodWswNmVzMnJudnRwZW8yY3huIn0.vRWDQDzqfwaEFquoc5SF3g',
          tilesize: 512,
          maximumLevel: 22
        }), 0
      );
    }
  }
  return (
    <>
      <div onClick={() => setMapThem('SAT')} className={'Sat'} style={MainTile}>
        <strong style={strongStyle} >Satellite</strong>
        <p style={category} >No roads or labels</p>
      </div>
      <FlexContainer>
        <Tile /*onClick={alert('fg')}*/ title="Navigation" bg={navigationImg} setMapTheme={setMapThem}>
          <p style={category} >No satellite base map</p>
        </Tile>
        <Tile title="Explore" bg={exploreImg} setMapTheme={setMapThem}>
          <p style={category} >Satellite, roads & places</p>
        </Tile>
      </FlexContainer>
    </>
  );
}

export default MapThemes;